<template>
    <div class="step-configuration">
        <v-card outlined class="step-card">
            <v-card-title class="step-card__title">
                {{ $t('surveys.wizard.configuration.cardTitle') }}
            </v-card-title>
            <v-card-subtitle class="step-card__subtitle">
                {{ $t('surveys.wizard.configuration.cardSubtitle') }}
            </v-card-subtitle>

            <v-card-text>
                <div class="config-option">
                    <div class="config-option__info">
                        <div class="config-option__label">
                            {{ $t('surveys.wizard.configuration.allowMultiple') }}
                        </div>
                        <div class="config-option__description">
                            {{ $t('surveys.wizard.configuration.allowMultipleDescription') }}
                        </div>
                    </div>
                    <v-switch
                        v-model="localConfig.allowMultipleResponses"
                        color="primary"
                        inset
                        dense
                        :readonly="readonly"
                        @change="emitUpdate"
                    ></v-switch>
                </div>

                <v-divider class="my-4"></v-divider>

                <v-alert
                    type="info"
                    color="primary lighten-5"
                    text
                    dense
                    class="config-alert"
                >
                    <span class="config-alert__text">
                        <b>{{ $t('surveys.wizard.configuration.noteTitle') }}</b>
                        {{ $t('surveys.wizard.configuration.noteText') }}
                    </span>
                </v-alert>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "StepConfiguration",
    props: {
        form: {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            localConfig: {
                allowMultipleResponses: this.form.allowMultipleResponses || false
            }
        };
    },

    watch: {
        form: {
            handler(newVal) {
                this.localConfig.allowMultipleResponses = newVal.allowMultipleResponses || false;
            },
            deep: true
        }
    },

    methods: {
        emitUpdate() {
            this.$emit('update', { ...this.localConfig });
        }
    }
};
</script>

<style lang="css" scoped>
    .step-configuration {
        width: 100%;
        max-width: 100%;
    }

    .step-card {
        border-radius: 16px !important;
        padding: 8px;
        width: 100%;
    }

    .step-card__title {
        font-size: 15px !important;
        font-weight: 700 !important;
        color: var(--v-primary-base);
    }

    .step-card__subtitle {
        font-size: 12px !important;
        color: #9A9AA6;
    }

    .config-option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 4px 0;
    }

    .config-option__label {
        font-size: 13px;
        color: #1F1F2B;
        font-weight: 600;
    }

    .config-option__description {
        font-size: 12px;
        color: #9A9AA6;
        margin-top: 2px;
    }

    .config-alert {
        border-radius: 10px !important;
    }

    .config-alert__text {
        font-size: 12px;
        color: var(--v-primary-base);
        line-height: 1.4;
    }
</style>
